import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LikeUser } from '../../models/comment/comment.model';

export interface LikesDialogData {
  commentContent: string;
  likedBy: LikeUser[];
  totalLikes: number;
}

@Component({
  selector: 'ptl-likes-dialog',
  templateUrl: './likes-dialog.component.html',
  styleUrls: ['./likes-dialog.component.scss'],
})
export class LikesDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LikesDialogData,
    public dialogRef: MatDialogRef<LikesDialogComponent>,
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  goToUserProfile(userId: string): void {
    // TODO: Navigate to user profile
    console.log('Navigate to user profile:', userId);
    this.dialogRef.close();
  }

  trackByUserId(index: number, user: LikeUser): string {
    return user.userId;
  }
}
